module.exports = __webpack_public_path__ + "static/media/ic-signout.6b76a1df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-signout.svg
// module id = 667
// module chunks = 14